module.exports = __webpack_public_path__ + "media/images/home-page/1-2@2x-763c2035957a24b0c9a5f82f7fda6abd.png";